export enum SeverityLevel {
  // As a standard, we only allow info and error
  //   VERBOSE = 0,
  INFORMATION = 1,
  //   WARNING = 2,
  ERROR = 3,
  //   CRITICAL = 4,
}

export enum AirlineCode {
  AS = 'AS',
  QX = 'QX',
  C = 'C',
}

export enum WebUrl {
  CONTRACTOR_WEB_URL_TYPE = 'CONTRACTOR_WEB_URL_TYPE',
  NON_CONTRACTOR_WEB_URL_TYPE = 'NON_CONTRACTOR_WEB_URL_TYPE',
}
